import * as React from 'react';
export const samsungSvg = React.forwardRef(function samsungSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#004599',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.016 13.242c.108.386.392.561.806.561.414 0 .68-.27.68-.59 0-.348-.24-.487-.882-.71-.676-.236-1.295-.47-1.295-1.277 0-.805.707-1.226 1.44-1.226.734 0 1.347.373 1.446 1.173h-.79c-.035-.203-.193-.564-.658-.564s-.643.341-.615.597c.027.245.157.446.848.668.664.214 1.316.499 1.316 1.27 0 .68-.485 1.314-1.557 1.314-1.073 0-1.472-.769-1.536-1.216h.797Zm12.617-.757c-.582-.153-.801-.263-.801-.478 0-.242.261-.378.53-.361.324.02.5.19.543.429h.68c-.05-.567-.521-1.002-1.259-1.002-.68 0-1.256.38-1.245.977.007.42.286.683.694.844.126.05.264.09.399.13.342.1.662.194.7.409.052.3-.244.466-.58.427-.29-.033-.455-.182-.533-.436h-.767c.127.666.635 1.033 1.357 1.033.76 0 1.299-.453 1.286-1.042-.015-.65-.696-.85-1.004-.93Zm-5.173-.806c-.445.02-.644.414-.644.86v1.808h-.715v-3.165h.715v.238c.16-.142.451-.314.839-.314.388 0 .717.128.917.447a1.36 1.36 0 0 1 1.034-.447c.59 0 1.112.35 1.112 1.149v2.092h-.715V12.32c-.005-.325-.167-.66-.592-.642-.445.02-.643.414-.644.86v1.81h-.715v-2.012c0-.33-.16-.676-.592-.657Zm-6.602 5.53c.468 0 .818.433.896.853h.82c-.173-.924-.876-1.52-1.74-1.52-1.096 0-1.834.892-1.834 2.229C4 20.108 4.738 21 5.834 21c.865 0 1.567-.596 1.74-1.52h-.82c-.078.42-.428.853-.896.853-.67 0-1.059-.713-1.059-1.562 0-.85.39-1.562 1.059-1.562Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.46 17.973v-1.286h.721v4.203h-.721v-.247c-.206.22-.504.357-.856.357-.86 0-1.431-.693-1.431-1.692 0-1 .57-1.692 1.431-1.692.352 0 .65.137.856.357Zm-1.566 1.335c0 .658.313 1.098.788 1.098.476 0 .767-.492.767-1.098 0-.607-.291-1.099-.767-1.099-.475 0-.787.44-.787 1.099Zm-3.777-1.335a1.15 1.15 0 0 0-.855-.357c-.861 0-1.432.693-1.432 1.692S8.4 21 9.262 21c.352 0 .65-.137.856-.357v.247h.721v-3.164h-.722v.247Zm-.777 2.433c-.475 0-.788-.44-.788-1.099 0-.658.313-1.098.788-1.098.475 0 .767.492.767 1.098 0 .607-.292 1.099-.767 1.099Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.45 17.802a.881.881 0 0 0-.383.317v-.394h-.721v3.165h.72s.004-1.132.002-1.314l-.001-.068c-.004-.216-.007-.434.086-.634.167-.362.55-.56.921-.55v-.635a1.18 1.18 0 0 0-.625.113Zm8.427-4.965c0 .364-.081 1.023-.641 1.023-.48 0-.577-.42-.577-.706v-1.971h-.719v2.09c0 .743.435 1.151 1.077 1.151.37 0 .666-.144.86-.364v.288h.719v-3.165h-.719v1.654Zm1.977-1.397c.16-.161.422-.333.839-.333.59 0 1.112.395 1.111 1.127v2.114h-.715V12.33c-.005-.325-.154-.671-.578-.653-.445.02-.657.415-.657.861v1.809h-.716v-3.165h.715v.256Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M27.282 11.429v-.246H28v2.74c0 .892-.484 1.562-1.406 1.562-.866 0-1.272-.532-1.365-1.028h.707c.021.079.176.445.707.413.492-.028.647-.41.647-.84v-.142a1.098 1.098 0 0 1-.837.364c-.858 0-1.331-.628-1.331-1.59 0-.96.473-1.589 1.33-1.589.35 0 .626.137.83.356Zm-1.442 1.234c0 .577.242.989.705.997.463-.008.726-.427.726-1.002 0-.574-.239-.993-.712-.993-.472 0-.719.42-.719.998ZM8.996 14.458c.351 0 .65-.137.855-.357v.247h.722v-3.165H9.85v.247a1.15 1.15 0 0 0-.855-.357c-.862 0-1.432.694-1.432 1.693 0 .999.57 1.692 1.432 1.692Zm.078-2.79c.475 0 .766.491.766 1.098 0 .606-.291 1.098-.766 1.098-.475 0-.788-.44-.788-1.098 0-.66.313-1.098.788-1.098Z',
      fill: '#fff',
    }),
  );
});
samsungSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var samsung = {
  category: 'brand',
  colorable: false,
  name: 'samsung',
  svg: samsungSvg,
};
